export default __webpack_public_path__ + "static/media/thum3.b44f62a3.jpg";